"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _get = _interopRequireDefault(require("lodash/get"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _treeView = _interopRequireDefault(require("britive-design-system/core/components/tree-view"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _radio = _interopRequireDefault(require("britive-design-system/core/components/radio"));

var _utils = require("./utils");

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = ".associations-tree-container {\n  margin-top: 10px; }\n\n.associations-selection-wrapper {\n  margin-top: 13px;\n  margin-left: 15px; }\n";
  var fileName = "compone_Associations";
  var element = document.querySelector("style[data-sass-component='compone_Associations']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var Associations = function Associations(_ref) {
  var _allowedScopes$enviro2;

  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$environmentGroup = _ref.environmentGroups,
      environmentGroups = _ref$environmentGroup === void 0 ? {} : _ref$environmentGroup,
      _ref$environments = _ref.environments,
      environments = _ref$environments === void 0 ? {} : _ref$environments,
      _ref$environmentData = _ref.environmentData,
      environmentData = _ref$environmentData === void 0 ? {} : _ref$environmentData,
      defaultDirectory = _ref.defaultDirectory,
      applicationRoot = _ref.applicationRoot,
      _ref$checkedNodes = _ref.checkedNodes,
      checkedNodes = _ref$checkedNodes === void 0 ? [] : _ref$checkedNodes,
      onChange = _ref.onChange,
      _ref$hideCheckboxes = _ref.hideCheckboxes,
      hideCheckboxes = _ref$hideCheckboxes === void 0 ? false : _ref$hideCheckboxes,
      _ref$hideDropdownFilt = _ref.hideDropdownFilter,
      hideDropdownFilter = _ref$hideDropdownFilt === void 0 ? false : _ref$hideDropdownFilt,
      _ref$hideUnselectedAs = _ref.hideUnselectedAssociationType,
      hideUnselectedAssociationType = _ref$hideUnselectedAs === void 0 ? false : _ref$hideUnselectedAs,
      _ref$singleSelect = _ref.singleSelect,
      singleSelect = _ref$singleSelect === void 0 ? false : _ref$singleSelect,
      _ref$allowOnlyEnviron = _ref.allowOnlyEnvironmentSelection,
      allowOnlyEnvironmentSelection = _ref$allowOnlyEnviron === void 0 ? false : _ref$allowOnlyEnviron,
      _ref$showSelectionLab = _ref.showSelectionLabel,
      showSelectionLabel = _ref$showSelectionLab === void 0 ? true : _ref$showSelectionLab,
      _ref$allowDisablingUn = _ref.allowDisablingUnselectedAssociation,
      allowDisablingUnselectedAssociation = _ref$allowDisablingUn === void 0 ? true : _ref$allowDisablingUn,
      filterSelectedScopeAsDefault = _ref.filterSelectedScopeAsDefault,
      allowedScopes = _ref.allowedScopes,
      _ref$showCreatedDate = _ref.showCreatedDate,
      showCreatedDate = _ref$showCreatedDate === void 0 ? false : _ref$showCreatedDate,
      _ref$allowRootSelecti = _ref.allowRootSelection,
      allowRootSelection = _ref$allowRootSelecti === void 0 ? true : _ref$allowRootSelecti,
      appName = _ref.appName,
      rightIconConfig = _ref.rightIconConfig,
      outOfSyncEnvironments = _ref.outOfSyncEnvironments;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      defaultDirectoryName = _useState2[0],
      setDefaultDirectoryName = _useState2[1];

  var _useState3 = (0, _react.useState)(_constants.customGroups),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedAssociationsType = _useState4[0],
      setSelectedAssociationsType = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      updatedCheckedNodes = _useState6[0],
      setUpdatedCheckedNodes = _useState6[1];

  var _useState7 = (0, _react.useState)([]),
      _useState8 = _slicedToArray(_useState7, 2),
      initialCheckedNodes = _useState8[0],
      setInitialCheckedNodes = _useState8[1];

  var _useState9 = (0, _react.useState)({}),
      _useState10 = _slicedToArray(_useState9, 2),
      associationsNodes = _useState10[0],
      setAssociationsNodes = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      isSelectedDefault = _useState12[0],
      setIsSelectedDefault = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = _slicedToArray(_useState13, 2),
      touched = _useState14[0],
      setTouched = _useState14[1];

  (0, _react.useEffect)(function () {
    !touched && setIsSelectedDefault(checkedNodes.length > 1 || checkedNodes.length === 1 && checkedNodes[0] !== defaultDirectory);
  }, [JSON.stringify(checkedNodes)]);
  (0, _react.useEffect)(function () {
    setDefaultDirectoryName((0, _get.default)(environmentGroups, "".concat(defaultDirectory, ".name")));
  }, [JSON.stringify(Object.keys(environmentGroups)), defaultDirectory]);
  (0, _react.useEffect)(function () {
    // This condition is added to prevent re-renders.
    if (checkedNodes.length === 0 || !(0, _isEqual.default)(checkedNodes, updatedCheckedNodes)) {
      setUpdatedCheckedNodes(_toConsumableArray(checkedNodes));
      selectRadioOption();
    }

    updateAssociationsNodes();
  }, [JSON.stringify(checkedNodes)]);
  (0, _react.useEffect)(function () {
    selectRadioOption();
    updateAssociationsNodes();
  }, [JSON.stringify(allowedScopes)]);

  var updateAssociationsNodes = function updateAssociationsNodes() {
    var nodes = (0, _utils.getTree)(environmentGroups, environments, checkedNodes, initialCheckedNodes, applicationRoot, defaultDirectory, environmentData, [].concat(_toConsumableArray((allowedScopes === null || allowedScopes === void 0 ? void 0 : allowedScopes.environments) || []), _toConsumableArray((allowedScopes === null || allowedScopes === void 0 ? void 0 : allowedScopes.environmentGroups) || [])), touched, rightIconConfig, outOfSyncEnvironments);
    setAssociationsNodes(nodes);
  };

  var selectRadioOption = function selectRadioOption() {
    if (!touched || disabled) {
      if ((0, _utils.isDefaultDirectorySelected)(checkedNodes, defaultDirectory)) {
        setSelectedAssociationsType(_constants.defaultAssociation);
      } else if (checkedNodes.length) {
        setSelectedAssociationsType(_constants.customGroups);
      } else {
        setSelectedAssociationsType(null);
      }
    }
  };

  var sendTheSelectedItems = function sendTheSelectedItems(selectedItems) {
    if (typeof onChange === 'function') {
      onChange(selectedItems);
    }
  };

  var handleNodeSelection = function handleNodeSelection(selectedNodes) {
    if (!touched) {
      // Setting the initial checked nodes to be used for comparison while highlighting
      // the edited ones. This block will be executed only once, since the touched value
      // changes to true later.
      setInitialCheckedNodes(_toConsumableArray(checkedNodes));
    }

    var newCheckedNodes = (0, _utils.getValuesFromTheSelectedNodes)(selectedNodes);
    setUpdatedCheckedNodes(newCheckedNodes);
    sendTheSelectedItems(newCheckedNodes);
    setTouched(true);
  };

  var handleRadioButtonSelection = function handleRadioButtonSelection(value) {
    setSelectedAssociationsType(value);

    if (value === _constants.defaultAssociation) {
      sendTheSelectedItems([defaultDirectory]);
    }
  };

  var addMarginToTheTree = defaultDirectoryName && !hideUnselectedAssociationType;
  var hasDefaultDirAndTreeNodes = (0, _utils.defaultDirectoryHasChildren)(environmentGroups, defaultDirectory);
  var shouldRenderTree = selectedAssociationsType === _constants.customGroups && hasDefaultDirAndTreeNodes || !defaultDirectoryName;
  var shouldRenderAssociationTypeSelection = !hideUnselectedAssociationType && defaultDirectoryName;
  var shouldRenderDefaultDirectoryName = hideUnselectedAssociationType && selectedAssociationsType === _constants.defaultAssociation;
  var associationTypeOptions = [{
    label: defaultDirectoryName,
    value: _constants.defaultAssociation,
    disabled: allowDisablingUnselectedAssociation ? (0, _utils.shouldDisableDefaultDirectory)(disabled, updatedCheckedNodes, defaultDirectory, _toConsumableArray((allowedScopes === null || allowedScopes === void 0 ? void 0 : allowedScopes.environmentGroups) || [])) : allowDisablingUnselectedAssociation
  }];

  if (hasDefaultDirAndTreeNodes) {
    var _allowedScopes$enviro;

    associationTypeOptions.push({
      label: _constants.customGroups,
      value: _constants.customGroups,
      disabled: allowDisablingUnselectedAssociation ? disabled || (allowedScopes === null || allowedScopes === void 0 ? void 0 : (_allowedScopes$enviro = allowedScopes.environmentGroups) === null || _allowedScopes$enviro === void 0 ? void 0 : _allowedScopes$enviro.length) && (allowedScopes === null || allowedScopes === void 0 ? void 0 : allowedScopes.environmentGroups[0]) === defaultDirectory : allowDisablingUnselectedAssociation
    });
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, shouldRenderDefaultDirectoryName && /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, defaultDirectoryName), shouldRenderAssociationTypeSelection ? /*#__PURE__*/_react.default.createElement("div", {
    className: "associations-selection-wrapper",
    "data-testid": "associations-selection-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_radio.default, {
    label: showSelectionLabel ? _constants.associationSelectionLabel : undefined,
    name: _constants.associationSelectionLabel,
    direction: 'vertical',
    defaultValue: selectedAssociationsType,
    options: associationTypeOptions,
    onChange: function onChange(event) {
      event.preventDefault();
      handleRadioButtonSelection(event.target.value);
    }
  })) : null, shouldRenderTree ? /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "associations-tree-container",
    className: "associations-tree-container",
    style: {
      marginLeft: addMarginToTheTree ? '43px' : 0
    }
  }, /*#__PURE__*/_react.default.createElement(_treeView.default, {
    nodes: associationsNodes,
    readOnly: disabled || (allowedScopes === null || allowedScopes === void 0 ? void 0 : (_allowedScopes$enviro2 = allowedScopes.environmentGroups) === null || _allowedScopes$enviro2 === void 0 ? void 0 : _allowedScopes$enviro2.length) && (allowedScopes === null || allowedScopes === void 0 ? void 0 : allowedScopes.environmentGroups[0]) === defaultDirectory,
    onChange: handleNodeSelection,
    isSelectedDefault: filterSelectedScopeAsDefault === undefined ? isSelectedDefault : filterSelectedScopeAsDefault,
    hideCheckboxes: hideCheckboxes,
    hideDropdownFilter: hideDropdownFilter,
    singleSelect: singleSelect,
    allowOnlyLeafSelection: allowOnlyEnvironmentSelection,
    allowRootSelection: allowRootSelection,
    showCreatedDate: showCreatedDate,
    rootLeafNodesFirst: (0, _utils.moveRootLevelLeavesAtTop)(appName)
  })) : null);
};

Associations.propTypes = {
  disabled: _propTypes.default.bool,
  environmentGroups: _propTypes.default.object,
  environments: _propTypes.default.object,
  environmentData: _propTypes.default.object,
  defaultDirectory: _propTypes.default.string,
  applicationRoot: _propTypes.default.object,
  checkedNodes: _propTypes.default.array,
  onChange: _propTypes.default.func,
  hideCheckboxes: _propTypes.default.bool,
  hideDropdownFilter: _propTypes.default.bool,
  hideUnselectedAssociationType: _propTypes.default.bool,
  singleSelect: _propTypes.default.bool,
  allowOnlyEnvironmentSelection: _propTypes.default.bool,
  showSelectionLabel: _propTypes.default.bool,
  allowDisablingUnselectedAssociation: _propTypes.default.bool,
  filterSelectedScopeAsDefault: _propTypes.default.bool,
  allowedScopes: _propTypes.default.object,
  showCreatedDate: _propTypes.default.bool,
  allowRootSelection: _propTypes.default.bool,
  appName: _propTypes.default.string,
  rightIconConfig: _propTypes.default.object,
  outOfSyncEnvironments: _propTypes.default.array
};
var _default = Associations;
exports.default = _default;